function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M269.3 56.7h-205l-7.6-42.5H0v28.3h33.4l30.4 170v.1h134.6v-28.3H87.1L82 155.9H262.2l21.3-99.2h-14.2zM76.9 127.6L69.3 85H249l-9.1 42.5-163 .1zm8.1 99.1c11.8 0 21.3 9.5 21.3 21.3s-9.5 21.3-21.3 21.3-21.3-9.5-21.3-21.3 9.5-21.3 21.3-21.3zm113.4 0c11.8 0 21.3 9.5 21.3 21.3s-9.5 21.3-21.3 21.3-21.3-9.5-21.3-21.3 9.5-21.3 21.3-21.3z"
})));